import { EAccess, EAccessMethod } from "@app/access/access.model";
import { EvideTableColumn, EvideTableColumnComponent, EvideTableColumnType } from "../common/common.model";

export interface INotificationRuleParameterHttpResponse {
  id: number;
  notificationRuleId: number;
  notificationParameterTypeId: number;
  notificationParameterTypeName: string;
  name: string;
  value: string;
}

export class NotificationRuleParameter {
  constructor(
    public id: number,
    public notificationRuleId: number,
    public notificationParameterTypeId: number,
    public notificationParameterTypeName: string,
    public name: string,
    public value: string
  ) { }

  public static adapt(data: INotificationRuleParameterHttpResponse) {
    return new this(
      data.id,
      data.notificationRuleId,
      data.notificationParameterTypeId,
      data.notificationParameterTypeName,
      data.name,
      data.value
    );
  }

  public static createBlank(notificationRuleId: number) {
    return new this(0, notificationRuleId, 0, '', '', '');
  }
}

export const NotificationRuleParameterColumns: Readonly<EvideTableColumn[]> = [
  {
    key: 'notificationParameterTypeId',
    type: EvideTableColumnType.Number,
    compType: EvideTableColumnComponent.Dropdown,
    isFormField: true,
    isFormEditableField: true,
    title: 'Notification Parameter Type',
    hideInList: true,
    required: true,
    placeholder: 'Please Select Notification Parameter Type',
    required_error: 'Notification Parameter Type is Required'
  },
  {
    key: 'notificationParameterTypeName',
    type: EvideTableColumnType.String,
    title: 'Notification Parameter Type',
    displayValue: true,
    sortable: true,
    isFormEditableField: false
  },
  {
    key: 'name',
    type: EvideTableColumnType.Text,
    compType: EvideTableColumnComponent.Input,
    isFormField: true,
    isFormEditableField: true,
    title: 'Name',
    displayValue: true,
    required: true,
    required_error: 'Name is Required',
    sortable: true
  },
  {
    key: 'value',
    type: EvideTableColumnType.Text,
    compType: EvideTableColumnComponent.Input,
    isFormField: true,
    isFormEditableField: true,
    title: 'Value',
    displayValue: true,
    required: false,
    sortable: true
  },
  {
    key: 'options',
    type: EvideTableColumnType.Options,
    matIcon: 'more_vert',
    title: 'Options',
    optionMenu: [
      {
        key: 'edit',
        type: EvideTableColumnType.Action,
        matIcon: 'fa fa-fw fa-pen',
        title: 'Edit',
        accessVisibility: {
          controllerKey: EAccess.NotificationRuleParameter,
          methodKey: EAccessMethod.Put
        }
      },
      {
        key: 'delete',
        type: EvideTableColumnType.Action,
        matIcon: 'fa fa-fw fa-trash-alt',
        title: 'Delete',
        accessVisibility: {
          controllerKey: EAccess.NotificationRuleParameter,
          methodKey: EAccessMethod.Delete
        }
      }
    ]
  }
];